import { graphql } from 'react-relay';

export const OrderHistoryViewerQuery = graphql`
  query OrderHistoryViewerQuery {
    viewer {
      user {
        id
        role
      }
    }
  }
`;
